var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.question !== null)?_c('div',{attrs:{"id":'question' + _vm.question.questionID.toString()}},[(_vm.question.questionType === _vm.questionTypeEnum.Information)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHTML)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }